import { IModule } from '@/@types'
import { create } from 'zustand'

interface FilterState {
  level: number | null
  selectedItem: IModule | null
  setFilters: (value: number) => void
  setSelectedItem: (value: IModule | null) => void
  clearFilters: () => void
  clearSelectedItem: () => void
}

export const useModulesStore = create<FilterState>((set) => ({
  level: null,
  selectedItem: null,
  setFilters: (value: number) => set({ level: value }),
  setSelectedItem: (value: IModule | null) => set({ selectedItem: value }),
  clearFilters: () => set({ level: null }),
  clearSelectedItem: () => set({ selectedItem: null }),
}))
